import { Action, combineReducers } from "redux";
import { IDocumentPage } from "source/models/document/documentPage";

// State
export interface IDocumentPageState {
    dataId: number;
    documentPage: IDocumentPage;
}

export interface IDocumentState {
    page: IDocumentPageState;
}

// Action type constants
const DOCUMENT_SUCCESS = "DOCUMENT_SUCCESS";
const DOCUMENT_FAILURE = "DOCUMENT_FAILURE";

type T_DOCUMENT_SUCCESS = typeof DOCUMENT_SUCCESS;
type T_DOCUMENT_FAILURE = typeof DOCUMENT_FAILURE;

// Action types
interface IDocumentSuccess extends Action {
    type: T_DOCUMENT_SUCCESS;
    documentPage: IDocumentPage;
}

interface IDocumentFailure extends Action {
    type: T_DOCUMENT_FAILURE;
}

export type DocumentAction =
    | IDocumentSuccess
    | IDocumentFailure;

//Actions
export const documentSuccess = (documentPage: IDocumentPage): IDocumentSuccess => ({
    type: DOCUMENT_SUCCESS,
    documentPage
});

export const documentFailure = (): IDocumentFailure => ({
    type: DOCUMENT_FAILURE
});

//Reducers
export const documentInitialState: IDocumentState = {
    page: {
        dataId: 0,
        documentPage: null
    }
};

const page = (state: IDocumentPageState = null, action: DocumentAction) => {
    switch (action.type) {
    case DOCUMENT_SUCCESS: {
        const documentSuccess = action as IDocumentSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            documentPage: documentSuccess.documentPage
        };
    }
    case DOCUMENT_FAILURE:
        return { ...state };
    }
    return state;
};

//Root reducer
export const documentReducer = combineReducers({
    page
});

//Utils